// extracted by mini-css-extract-plugin
module.exports = {"item":"item-MVm-b","root":"root-3eoh4","name":"name-397Vh","size":"size-2idek"};